import { ref, computed } from 'vue';
import { authService, type PasswordResetRequest, AuthApiError } from '@/services/authService';

export function usePasswordReset() {
  const loading = ref(false);
  const successMessage = ref('');
  const errorMessage = ref('');

  const resetMessages = () => {
    successMessage.value = '';
    errorMessage.value = '';
  };

  const setErrorMessage = (message: string) => {
    errorMessage.value = message;
  };

  const setSuccessMessage = (message: string) => {
    successMessage.value = message;
  };

  const handleError = (error: any) => {
    console.error('Password reset error:', error);
    
    if (error instanceof AuthApiError) {
      errorMessage.value = error.message;
    } else if (error.response?.data?.message) {
      errorMessage.value = error.response.data.message;
    } else {
      errorMessage.value = 'An error occurred. Please try again.';
    }
  };

  const requestPasswordReset = async (email: string) => {
    loading.value = true;
    resetMessages();

    try {
      const data: PasswordResetRequest = { email };
      const response = await authService.requestPasswordReset(data);
      
      if (response.success) {
        successMessage.value = response.message || 'Password reset instructions sent to your email';
        return true;
      } else {
        errorMessage.value = response.message || 'Failed to send password reset email';
        return false;
      }
    } catch (error) {
      handleError(error);
      return false;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: computed(() => loading.value),
    successMessage: computed(() => successMessage.value),
    errorMessage: computed(() => errorMessage.value),
    requestPasswordReset,
    resetMessages,
    setErrorMessage,
    setSuccessMessage
  };
} 